import ApplicationConfig from '@/lib/application-config'
import { aidToUtcObject } from '@/lib/filters'
import moment from 'moment'
import * as Constants from '@/lib/constants'

export default class UTCDateTime {
  static toYearMonthDay(utcString) {
    const utc = UTCDateTime.toUtcMoment(utcString)
    if (utc) {
      return utc.tz(Constants.DEFAULT_TIMEZONE).format(ApplicationConfig.getUserDateMomentFormat())
    }
    return ''
  }

  static toYearMonthDayHourMin(utcString) {
    const utc = UTCDateTime.toUtcMoment(utcString)
    if (utc) {
      return utc.tz(Constants.DEFAULT_TIMEZONE).format(ApplicationConfig.getUserDateMomentFormat() + ' HH:mm')
    }
    return ''
  }

  static toHourMin(utcString) {
    const utc = UTCDateTime.toUtcMoment(utcString)
    if (utc) {
      return utc.tz(Constants.DEFAULT_TIMEZONE).format('HH:mm')
    }
    return ''
  }

  static toYearMonth(utcString) {
    const utc = UTCDateTime.toUtcMoment(utcString)
    if (utc) {
      return utc.tz(Constants.DEFAULT_TIMEZONE).format(ApplicationConfig.getUserMonthMomentFormat())
    }
    return ''
  }

  static utcStringNow() {
    const now = moment()
    return UTCDateTime.utcStringFromMomentObject(now)
  }

  static utcStringFromMomentObject(utcMomentObject) {
    return utcMomentObject.utc().format(Constants.UTC_FORMAT_DEFAULT)
  }

  static toUtcMoment(utcStringOrNumber) {
    let type = typeof utcStringOrNumber
    if (type === 'string') {
      let year = utcStringOrNumber.slice(0, 4)
      let month = utcStringOrNumber.slice(5, 7)
      let date = utcStringOrNumber.slice(8, 10)
      let hours = utcStringOrNumber.slice(11, 13)
      let minutes = utcStringOrNumber.slice(14, 16)
      let seconds = utcStringOrNumber.slice(17, 29)
      let milliseconds = utcStringOrNumber.slice(20, 23)

      let utc = moment.utc({
        year: year,
        month: parseInt(month) - 1,
        date: date,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
        milliseconds: milliseconds,
      })
      return utc
    }
    if (type === 'number') {
      return moment.unix(utcStringOrNumber).utc()
    }
    if (type === 'undefined') {
      return undefined
    }
    console.error('invalid argument: ' + utcStringOrNumber)
    return undefined
  }
}
